module.exports = __webpack_public_path__ + "img/media-10.d2bf99c4.png";